import { useEffect } from 'react'

import { ForgotPasswordForm } from '../Components/ForgotPasswordForm'
import { FormWrapper } from '../Components/FormWrapper'

/**
 * Відновлення пароля кодом на пошту (`SPEC-005` §7.4). Заголовок вкладки —
 * українською прямо тут: ключа `Password recovery` у перекладах немає.
 */
export default function ForgotPasswordPage() {
    useEffect(() => {
        document.title = 'Відновлення пароля'
    }, [])

    return (
        <FormWrapper>
            <ForgotPasswordForm />
        </FormWrapper>
    )
}
